import hoistNonReactStatics from 'hoist-non-react-statics'
import {ComponentType} from 'react'

/**
 * HOC to reuse prop as key.
 *
 * TODO: move this where it belongs
 */
export const withKeyFromProp = <P extends {}, C extends ComponentType<P>>(
  Comp: C,
  k: keyof P,
) => {
  const KeyedComp = (props: any) => <Comp key={props[k]} {...props} />
  hoistNonReactStatics(KeyedComp, Comp)
  KeyedComp.displayName = `withKeyFromProp(${Comp.displayName || Comp.name || 'Unknown'})`
  return KeyedComp as C
}
